import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import store from "./store";
import App from './App/index';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import "./index.css";
// import config from './config';
import registerServiceWorker from "./registerServiceWorker";

const app = (
    <Provider store={store}>
        {/* <BrowserRouter basename={config.basename}>
            <App />
        </BrowserRouter> */}
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
registerServiceWorker();
